import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Box from "@mui/material/Box";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";

const MAX_RETRIES = 2;

const ERROR_MESSAGES = {
  "Incompatible Brand": "La marca/planta no puede servir esa ubicación.",
  "Insufficient Capacity": "No hay unidades con capacidad suficiente.",
  "Out of Polygon": "Dirección fuera del área de cobertura.",
  "Route with less than 3 points": "Ruta insuficiente para optimización.",
  "Unit without Polygon": "Unidad sin poligono asignado.",
  mobile_type_incompatibility: "Tipo de unidad móvil incompatible.",
  "no time available": "No hay ventanas de tiempo disponibles.",
  product_type_incompatible: "Producto incompatible con unidades disponibles.",
  stationary_type_incompatibility: "Tipo de unidad estacionaria incompatible.",
  product_type_incompatibility: "Producto incompatible con unidades disponibles.",
};

const getErrorMessage = (definitiveReason) => {
  if (!definitiveReason) return null;
  const firstKey = Object.keys(definitiveReason)[0];
  const errorCode = definitiveReason[firstKey];
  return ERROR_MESSAGES[errorCode] || errorCode;
};

const getAlertConfig = (suggestionStatus, retryCount, unitsOpt, selectedBrand) => {
  const hasUnitsForBrand =
    selectedBrand && selectedBrand.idBrand !== "todos"
      ? unitsOpt.some((unit) => unit.idBrand === selectedBrand.idBrand)
      : unitsOpt.length > 0;

  if (!hasUnitsForBrand) return null;

  if (retryCount >= MAX_RETRIES) {
    return {
      text: "Límite de intentos alcanzados",
      backgroundColor: "rgb(244, 244, 244)",
      color: "#666",
      icon: <CancelIcon style={{ fontSize: 16 }} />,
    };
  }

  const configs = {
    info: {
      text: "Generando sugerencias",
      backgroundColor: "rgb(244, 244, 244)",
      color: "#666",
      icon: <AutorenewIcon style={{ fontSize: 16 }} />,
    },
    success: {
      text: "Se encontraron coincidencias",
      backgroundColor: "rgb(186, 243, 196)",
      color: "rgb(37, 83, 32)",
      icon: <CheckIcon style={{ fontSize: 16 }} />,
    },
    warning: {
      text: getErrorMessage(suggestionStatus.definitiveReason) || "Sin coincidencias",
      backgroundColor: "#ffebee",
      color: "#d32f2f",
      icon: <CloseIcon style={{ fontSize: 16 }} />,
    },
    error: {
      text: "Sin coincidencias",
      backgroundColor: "#ffebee",
      color: "#d32f2f",
      icon: <CloseIcon style={{ fontSize: 16 }} />,
    },
  };

  return configs[suggestionStatus.status] || null;
};

export const SuggestionAlert = ({
  suggestionStatus,
  retryCount,
  unitsOpt,
  selectedBrand,
  onRetry,
}) => {
  const config = getAlertConfig(suggestionStatus, retryCount, unitsOpt, selectedBrand);
  if (!suggestionStatus.show || !config) return null;

  const canRetry =
    (suggestionStatus.status === "warning" ||
      suggestionStatus.status === "error" ||
      suggestionStatus.status === "success") &&
    retryCount < MAX_RETRIES;

  return (
    <Grid item xs={12}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box
          px={2}
          py={1}
          borderRadius={1}
          display="flex"
          alignItems="center"
          gap={1}
          style={{
            backgroundColor: config.backgroundColor,
            color: config.color,
          }}
        >
          {config.icon}
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            {config.text}
          </Typography>
        </Box>

        {canRetry && (
          <Box
            onClick={onRetry}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              cursor: "pointer",
              color: "rgb(58, 134, 238)",
              textDecoration: "underline",
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            REINTENTAR
            <RefreshIcon style={{ fontSize: 16, color: "rgb(58, 134, 238)" }} />
          </Box>
        )}
      </Box>
    </Grid>
  );
};
